import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem, Button } from "reactstrap"

const Breadcrumb = props => {
  return (
    <Row>
      {/* <Col xs="12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0 font-size-18">
            <Button className="btn  " style={{ marginTop: '-20px', marginBottom: "-15px", backgroundColor: "#143758", cursor:"default" }} >
              {props.breadcrumbItem}
            </Button>
          </h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
             
            </ol>
          </div>
        </div>
      </Col> */}
       <Col xs="12">
        <div className="page-title-box d-flex align-items-center justify-content-between">
          <h4 className="mb-0 font-size-18">
            {props.alternateTitle ? props.alternateTitle : props.title}
          </h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to="#">{props.title}</Link>
              </BreadcrumbItem>
              {props.breadcrumbItem2 ? (
                <BreadcrumbItem>
                  <Link to="#">{props.breadcrumbItem1}</Link>
                </BreadcrumbItem>
              ) : (
                <BreadcrumbItem active>
                  <Link to="#">{props.breadcrumbItem1}</Link>
                </BreadcrumbItem>
              )}
              {props.breadcrumbItem2 && (
                <BreadcrumbItem active>
                  <Link to="#">{props.breadcrumbItem2}</Link>
                </BreadcrumbItem>
              )}
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
}

export default Breadcrumb
